import { memo } from 'react'
import { ViewMode } from '../../../constants/enums'
import dynamicWithRetry, {
    loadWithRetry,
} from '../../../utilities/dynamicWithRetry'
import { useHealthAppStateSelector } from '../../Hooks/useHealthAppState'
import {
    useConfirmationSelector,
    useDialogSelector,
    useDrawerSelector,
    useFloatingRoomStateSelector,
} from '../../Hooks/useModal'
import DisconnectWarningSnackbar from '../Modals/DisconnectWarningSnackbar'

loadWithRetry(() => import('../Modals/Dialog')).catch(() => undefined)
const AppDialog = dynamicWithRetry(() => import('../Modals/Dialog'))
const AppConfirmation = dynamicWithRetry(() => import('../Modals/Confirmation'))
const AppDrawer = dynamicWithRetry(() => import('../Modals/Drawer'))
interface ModalLayoutProps {
    showConnectingScreen: boolean
    delayReconnectionScreen: boolean
}

const Modals = (props: ModalLayoutProps) => {
    const { showConnectingScreen, delayReconnectionScreen } = props
    const showConfirmation = useConfirmationSelector('show')
    const showDialog = useDialogSelector('show')
    const showDrawer = useDrawerSelector('show')
    const viewMode = useFloatingRoomStateSelector('viewMode')
    const fullWindow = viewMode === ViewMode.FullWindow
    const socketPaused = useHealthAppStateSelector('paused')
    return (
        <>
            {showConnectingScreen && !delayReconnectionScreen && (
                <DisconnectWarningSnackbar paused={socketPaused} />
            )}
            {showDialog && <AppDialog />}
            {showDrawer && <AppDrawer fullWindow={fullWindow} />}
            {showConfirmation && <AppConfirmation />}
        </>
    )
}

export default memo(Modals)
